export default __webpack_public_path__ + "static/media/mentors.78bc27fd.svg";